<template>
  <div class="cat-list-tile">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatListTile"
});
</script>
